module.exports = __webpack_public_path__ + "static/media/HD720_HMR_Haia.5cb953b2.mp4";